import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  template: `
    <div class="section-label">
    <hr/><strong>{{ to?.label }}</strong><hr/>
        <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class PanelWrapperComponent extends FieldType {
  @ViewChild('fieldComponent', {read: ViewContainerRef,static: false}) fieldComponent: ViewContainerRef;
}